import * as React from 'react';
import { TextInput, useInput, required } from 'react-admin';

const SnInput = (props) => {
    const {
        source,
        validate,
        label,
        helperText,
        ...rest
    } = props;

    // 使用 react-admin 的输入管理
    const { field, fieldState } = useInput({
        source,
        validate,
        ...rest
    });

    const inputRef = React.useRef<HTMLInputElement>(null);
    const [currentInput, setCurrentInput] = React.useState('');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // console.log('change', e, field)
        // setCurrentInput(e.target.value);
        const newValue = e.target.value;
        let oldSn = currentInput.trim();

        // 如果新值不包含旧值（且两者都不为空）
        if (oldSn && !newValue.includes(oldSn)) {
            setCurrentInput(newValue);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            let oldSn = currentInput.trim();
            let newSn = field.value.replace(oldSn, "")
            const newValue = oldSn ? `${oldSn},${newSn}` : newSn;

            field.onChange(newValue);
            setCurrentInput(newValue);
            console.log('key', newSn, field)
        }
    };

    return (
        <TextInput
            label={label}
            source={source}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            inputRef={inputRef}
            validate={validate}
            fullWidth
            multiline
            helperText={helperText || "使用扫码枪扫描设备SN，按回车确认添加"}
        />
    );
};

export default SnInput;